export enum ETrackingStages {
    CAR_AT_GARAGE = 'CAR_AT_GARAGE',
    SURVEY = 'SURVEY',
    ESTIMATE_APPROVAL_PENDING = 'ESTIMATE_APPROVAL_PENDING',
    ESTIMATE_COMPLETED = 'ESTIMATE_COMPLETED',
    REPAIR_IN_PROGRESS = 'REPAIR_IN_PROGRESS',
    QUALITY_CHECK = 'QUALITY_CHECK',
    PAYMENT_PENDING = 'PAYMENT_PENDING',
    PAYMENT_COMPLETED = 'PAYMENT_COMPLETED',
    CAR_DELIVERED = 'CAR_DELIVERED',
    NO_SERVICE_SELECTED = 'NO_SERVICE_SELECTED',
}

export const TimelineStageTitle = {
    WELCOME: 'Welcome',
    [ETrackingStages.CAR_AT_GARAGE]: 'Car at garage',
    [ETrackingStages.SURVEY]: 'Survey',
    [ETrackingStages.ESTIMATE_APPROVAL_PENDING]: 'Estimate approval pending',
    [ETrackingStages.ESTIMATE_COMPLETED]: 'Estimate completed',
    [ETrackingStages.REPAIR_IN_PROGRESS]: 'Repair in progress',
    [ETrackingStages.QUALITY_CHECK]: 'Quality check',
    [ETrackingStages.PAYMENT_PENDING]: 'Payment pending',
    [ETrackingStages.PAYMENT_COMPLETED]: 'Payment received',
    [ETrackingStages.CAR_DELIVERED]: '',
    [ETrackingStages.NO_SERVICE_SELECTED]: '',
};

export const TimelineNextStep = {
    [ETrackingStages.CAR_AT_GARAGE]:
        'We will examine your car service and repair needs',
    [ETrackingStages.SURVEY]: 'We will share a service related work estimate',
    [ETrackingStages.ESTIMATE_APPROVAL_PENDING]:
        'Once approved, we will start the service',
    [ETrackingStages.ESTIMATE_COMPLETED]:
        'Your selected services will start soon',
    [ETrackingStages.REPAIR_IN_PROGRESS]:
        'After the repairs are over, we’ll do a quality check',
    [ETrackingStages.QUALITY_CHECK]: 'We will share the final invoice soon',
    [ETrackingStages.PAYMENT_PENDING]:
        'After payment, you can schedule your car drop',
    [ETrackingStages.PAYMENT_COMPLETED]: 'Servicing done',
    [ETrackingStages.CAR_DELIVERED]: '',
    [ETrackingStages.NO_SERVICE_SELECTED]: '',
};

export enum PageRoutes {
    ERROR = '/error',
    TRACKING = '/tracking',
    JOBCARD = '/job-cards',
    ESTIMATE = '/estimate-approval',
    REDIRECT = '/stage-redirect',
    WELCOME = '/home',
    ESTIMATE_BREAKDOWN = '/service-estimate',
}
const trackingPages = [
    ETrackingStages.CAR_AT_GARAGE,
    ETrackingStages.SURVEY,
    ETrackingStages.REPAIR_IN_PROGRESS,
    ETrackingStages.PAYMENT_PENDING,
    ETrackingStages.QUALITY_CHECK,
    ETrackingStages.PAYMENT_COMPLETED,
    ETrackingStages.CAR_DELIVERED,
];

export const getRoute = (stage: string) => {
    const isTrackingPage = trackingPages.includes(stage as any);
    return isTrackingPage ? PageRoutes.TRACKING : routeMap[stage];
};

export const routeMap: any = {
    WELCOME: PageRoutes.WELCOME,
    [ETrackingStages.ESTIMATE_APPROVAL_PENDING]: PageRoutes.JOBCARD,
    [ETrackingStages.ESTIMATE_COMPLETED]: PageRoutes.ESTIMATE,
};
